import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordRulesValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    const errors: any = {};

    if (value.length < 6 || value.length > 12) {
      errors.length = true;
    }

    if (!/[a-z]/.test(value)) {
      errors.lowercase = true;
    }

    if (!/[A-Z]/.test(value)) {
      errors.uppercase = true;
    }

    if (!/[0-9]/.test(value)) {
      errors.digit = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
